import { makeStyles } from 'tss-react/mui';

export const useSlideViewerAppBarStyles = makeStyles()(() => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    minWidth: 0,
    color: '#fff',
    // The breadcrumb must truncate instead of pushing the search bar away.
    '& p': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '1.05rem',
    },
  },
  star: {
    padding: 0,
    flexShrink: 0,
  },
  starIcon: {
    width: '1.5rem',
    height: '1.5rem',
    color: '#fff',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    marginRight: '0.5rem',
    flexShrink: 0,
    // The palette menu button inherits the app bar's white.
    '& .MuiIconButton-root': {
      color: 'inherit',
    },
  },
}));
